// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var I18n = require("../../../shared/utils/I18n.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var FaIcon = require("../../../shared/components/FaIcon.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_option = require("rescript/lib/js/js_option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var GraphqlQuery = require("../../../shared/utils/GraphqlQuery.bs.js");
var CoursesCurriculum__Course = require("../types/CoursesCurriculum__Course.bs.js");

var partial_arg = "components.CoursesCurriculum__LevelUpButton";

function t(param, param$1, param$2) {
  return I18n.t(partial_arg, param, param$1, param$2);
}

function str(prim) {
  return prim;
}

var ppx_printed_query = "mutation LevelUpMutation($courseId: ID!)  {\nlevelUp(courseId: $courseId)  {\nsuccess  \n}\n\n}\n";

function parse(value) {
  var value$1 = Js_option.getExn(Js_json.decodeObject(value));
  var value$2 = Js_dict.get(value$1, "levelUp");
  var tmp;
  if (value$2 !== undefined) {
    var value$3 = Js_option.getExn(Js_json.decodeObject(Caml_option.valFromOption(value$2)));
    var value$4 = Js_dict.get(value$3, "success");
    var tmp$1;
    if (value$4 !== undefined) {
      var value$5 = Caml_option.valFromOption(value$4);
      var value$6 = Js_json.decodeBoolean(value$5);
      tmp$1 = value$6 !== undefined ? value$6 : Js_exn.raiseError("graphql_ppx: Expected boolean, got " + JSON.stringify(value$5));
    } else {
      tmp$1 = Js_exn.raiseError("graphql_ppx: Field success on type LevelUpPayload is missing");
    }
    tmp = {
      success: tmp$1
    };
  } else {
    tmp = Js_exn.raiseError("graphql_ppx: Field levelUp on type Mutation is missing");
  }
  return {
          levelUp: tmp
        };
}

function make(courseId, param) {
  return {
          query: ppx_printed_query,
          variables: Js_dict.fromArray([[
                    "courseId",
                    courseId
                  ]].filter(function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  })),
          parse: parse
        };
}

function makeWithVariables(variables) {
  var courseId = variables.courseId;
  return {
          query: ppx_printed_query,
          variables: Js_dict.fromArray([[
                    "courseId",
                    courseId
                  ]].filter(function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  })),
          parse: parse
        };
}

function makeVariables(courseId, param) {
  return Js_dict.fromArray([[
                  "courseId",
                  courseId
                ]].filter(function (param) {
                  return !Js_json.test(param[1], /* Null */5);
                }));
}

function definition_2(graphql_ppx_use_json_variables_fn, courseId, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray([[
                      "courseId",
                      courseId
                    ]].filter(function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    })));
}

var definition = [
  parse,
  ppx_printed_query,
  definition_2
];

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var LevelUpQuery = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  make: make,
  makeWithVariables: makeWithVariables,
  makeVariables: makeVariables,
  definition: definition,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

function handleSubmitButton(saving) {
  var submitButtonText = function (title, iconClasses) {
    return React.createElement("span", undefined, React.createElement(FaIcon.make, {
                    classes: iconClasses + " mr-2"
                  }), title);
  };
  if (saving) {
    return submitButtonText(t(undefined, undefined, "button_text_saving"), "fas fa-spinner fa-spin");
  } else {
    return submitButtonText(t(undefined, undefined, "button_text_level_up"), "fas fa-flag");
  }
}

function refreshPage(param) {
  window.location.reload();
  
}

function createLevelUpQuery(course, setSaving, $$event) {
  $$event.preventDefault();
  Curry._1(setSaving, (function (param) {
          return true;
        }));
  GraphqlQuery.sendQuery(undefined, make(CoursesCurriculum__Course.id(course), undefined)).then(function (response) {
        if (response.levelUp.success) {
          window.location.reload();
        } else {
          Curry._1(setSaving, (function (param) {
                  return false;
                }));
        }
        return Promise.resolve(undefined);
      });
  
}

function CoursesCurriculum__LevelUpButton(Props) {
  var course = Props.course;
  var match = React.useState(function () {
        return false;
      });
  var setSaving = match[1];
  var saving = match[0];
  return React.createElement("button", {
              className: "btn btn-success btn-large w-full md:w-4/6 mt-4",
              disabled: saving,
              onClick: (function (param) {
                  return createLevelUpQuery(course, setSaving, param);
                })
            }, handleSubmitButton(saving));
}

var make$1 = CoursesCurriculum__LevelUpButton;

exports.t = t;
exports.str = str;
exports.LevelUpQuery = LevelUpQuery;
exports.handleSubmitButton = handleSubmitButton;
exports.refreshPage = refreshPage;
exports.createLevelUpQuery = createLevelUpQuery;
exports.make = make$1;
/* react Not a pure module */
